/**
 * A file's or a layer's day as Board 9 prints it — *Tue* within the six days
 * before the server's `now`, else *Oct 14* (*12 pages · Tue*, *1 page · Oct
 * 14*, *drawn by Tom Reyes · Oct 6*), in the visit's own zone.
 *
 * Compared with the server's clock as the read model sent it
 * (`VisitRead.now`), never the page's own. Everything else is `format.ts`'s
 * `timeIn`.
 */
import { formatInTimeZone } from 'date-fns-tz'
import type { IsoMoment } from '@rowted/shared'
import { timeIn } from './format.js'

export function recentDay(timeZone: string, at: IsoMoment, now: IsoMoment): string {
  const day = Date.parse(`${formatInTimeZone(new Date(at), timeZone, 'yyyy-MM-dd')}T00:00:00Z`)
  const today = Date.parse(`${formatInTimeZone(new Date(now), timeZone, 'yyyy-MM-dd')}T00:00:00Z`)
  const days = Math.round((today - day) / 86_400_000)
  return days >= 0 && days <= 6 ? timeIn(timeZone, at, 'day') : timeIn(timeZone, at, 'monthDay')
}
